/**
 * 월간 이슈 브리프 — 생보/손보 카드뉴스 이미지 파일명·슬라이드 매칭 유틸.
 * 이미지 저장 키: monthly_brief_{briefId}_{storageSlideId}.png
 * storageSlideId = life_|fire_ + (payload.slideId || slide-{idx})
 */

export function monthlyBriefSlideStorageId(briefTab, slide, idx) {
    const base = slide?.slideId || `slide-${idx}`
    return `${briefTab === 'life' ? 'life_' : 'fire_'}${base}`
}

/** monthly_brief_123_life_slide-1.png → life_slide-1 (확장자 변형 대비) */
export function parseStorageSlideIdFromMonthlyBriefImageName(imageName) {
  const m = String(imageName || '').match(/monthly_brief_\d+_(.+)\.(?:png|webp|jpe?g)$/i)
  return m ? m[1] : null
}

export function filterMonthlyBriefImagesByKind(images, kind) {
  return (images || []).filter((img) => {
    const sid = parseStorageSlideIdFromMonthlyBriefImageName(img?.imageName)
    if (!sid) return false
    if (sid.startsWith('life_')) return kind === 'life'
    if (sid.startsWith('fire_')) return kind === 'fire'
    // 구버전(접두사 없음): 생보 모달에만 노출 (중복 방지)
    return kind === 'life'
  })
}

export function sortMonthlyBriefImagesBySlideOrder(images, payload, kind) {
    const brief = kind === 'life' ? payload?.lifeBrief : payload?.fireBrief
    const slides = Array.isArray(brief?.slides) ? brief.slides : []
    const prefixed = slides.map((s, i) => `${kind === 'life' ? 'life_' : 'fire_'}${s.slideId || `slide-${i}`}`)
    const legacy = slides.map((s, i) => s.slideId || `slide-${i}`)

    const rank = (imageName) => {
        const sid = parseStorageSlideIdFromMonthlyBriefImageName(imageName)
        if (!sid) return 999
        let idx = prefixed.indexOf(sid)
        if (idx >= 0) return idx
        idx = legacy.indexOf(sid)
        return idx >= 0 ? idx : 500
    }
    return [...(images || [])].sort((a, b) => rank(a.imageName) - rank(b.imageName))
}

/** storageSlideId 또는 파일명에서 추출한 id로 슬라이드 메타(title, body, tags) 조회 */
export function findSlideMetaForMonthlyBriefImage(payload, kind, storageSlideId) {
    if (!payload || !storageSlideId) return null
    const brief = kind === 'life' ? payload.lifeBrief : payload.fireBrief
    const slides = Array.isArray(brief?.slides) ? brief.slides : []
    const prefix = kind === 'life' ? 'life_' : 'fire_'
    let raw = storageSlideId
    if (raw.startsWith(prefix)) raw = raw.slice(prefix.length)
    const found = slides.find((s, i) => (s.slideId || `slide-${i}`) === raw)
    return found || null
}
